<template>
  <booking>
    <div class="booking-need-to-upload">
      <div class="lists">
        <booking-box-need-to-upload
          v-for="(item, index) in reservations"
          :key="index"
          :data="item"
        ></booking-box-need-to-upload>
      </div>
    </div>
  </booking>
</template>

<script>
import Booking from '../photographer/Booking'
import BookingBoxNeedToUpload from '../common/BookingBoxNeedToUpload'
import { getNeedUploadReservationsForPhotographer } from '../../api/reservation'

export default {
  name: 'booking-need-to-upload',
  components: { BookingBoxNeedToUpload, Booking },
  data() {
    return {
      reservations: []
    }
  },
  created() {
    this.getNeedUploadReservationsForPhotographer()
  },
  methods: {
    getNeedUploadReservationsForPhotographer() {
      getNeedUploadReservationsForPhotographer(
        this.$store.getters.userInfo.uid
      ).then(res => {
        this.reservations = res
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.booking-need-to-upload {
  .lists {
    margin: 30px 0 0 0;
    .booking-box-need-to-upload {
      margin: 0 0 10px 0;
    }
  }
}
</style>
